import React, {useEffect, useState} from 'react';
import ResizableBox from "../../utils/ResizableBox";
import {Bar} from "react-chartjs-2";
import axios from "axios";
import {BASE_NAME} from "../../../../../services/utils/ApiUrls";
import moment from "moment";
import {getConfig} from "../../../../../services/utils/ConfigUtils";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {Backdrop, Card, CardContent, CardHeader, CircularProgress, TextField, Typography} from "@mui/material";
import clsx from "clsx";
import { Autocomplete } from '@mui/material';
import {spAslCode} from "../../../../../utils/dictionaries/Generics";
import {PaperComponent} from "../../../../../styles/components/DynamicComponentStyle";

const options = {
	responsive: true,
	plugins: {
		legend: {
			position: 'top',
		},
		title: {
			display: true,
			text: 'Numero di ticket per giorno suddivisi per stato',
		},
	},
};

export const TicketGiornoStato = () => {
	const classes = BaseStyle();
	const [dataGrafico, setDataGrafico] = useState(new Date());
	const [loading, setLoading] = useState(false);
	const [asl, setAsl] = useState("SP_301");
	const [data, setData] = useState({
		labels: ['01/12/2021'],
		datasets: [
			{
				label: 'I love you',
				data: [3000],
				backgroundColor: 'rgba(255, 99, 132, 0.5)',
				stack: 'Stack 0',
			},
		],
	})

	useEffect(() => {
		setDataGrafico(new Date())
	}, [])

	useEffect(() => {
		setLoading(true);
		axios
			.get(BASE_NAME + "ticket/getStatsByDate/" + moment(dataGrafico).format("DD-MM-YYYY"), getConfig())
			.then((response) => {
				let newData1 = {
					labels: response.data.map(item => moment(new Date(item.label)).format("DD/MM/YYYY")),
					datasets: [
						{
							label: 'Nuovi',
							data: response.data.map(elem => elem.data["Nuovi"].sum),
							backgroundColor: 'rgba(255,0,0,0.5)',
							stack: 'Stack 0',
						},
						{
							label: 'Aperti',
							data: response.data.map(elem => elem.data["Aperti"].sum),
							backgroundColor: 'rgba(247,0,255,0.5)',
							stack: 'Stack 0',
						},
						{
							label: 'Presi in carico',
							data: response.data.map(elem => elem.data["Presi in carico"].sum),
							backgroundColor: 'rgba(0,208,255,0.5)',
							stack: 'Stack 0',
						},
						{
							label: 'In attesa',
							data: response.data.map(elem => elem.data["In attesa"].sum),
							backgroundColor: 'rgba(0,164,29,0.5)',
							stack: 'Stack 0',
						},
						{
							label: 'Risolti',
							data: response.data.map(elem => elem.data["Risolti"].sum),
							backgroundColor: 'rgba(255,126,0,0.5)',
							stack: 'Stack 0',
						},
					]
				}

				setData(newData1);
				setLoading(false)
				console.log(response.data)
			})
			.catch((error) => {
				setLoading(false);
				console.log(JSON.stringify(error))
			})
	}, [dataGrafico, asl])

	return (
		<React.Fragment>
			<Backdrop open={loading} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>

			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Ticket giorno - stato</b></Typography>}
					subheader={"Numero di ticket (asse y) per giorno (asse x) suddivisi per stato (colore)"}
				/>
				<CardContent style={{flexGrow: 1, overflow: "scroll"}}>

					<ResizableBox width={1200} height={600}>
						<Bar options={options} data={data} type={"bar"}/>
					</ResizableBox>

					<Autocomplete
						value={asl}
						onChange={(event, newValue) => {
							setAsl(newValue);
						}}
						PaperComponent={PaperComponent}
						multiple={false}
						id="controllable-states-demo"
						options={Object.entries(spAslCode).map(([key]) => key)}
						style={{width: "100%", paddingTop: 20}}
						disabled={true}
						renderInput={(params) => <TextField {...params} label="Filtri" variant="outlined"/>}
					/>

				</CardContent>
			</Card>
		</React.Fragment>
	);
};
